/* eslint-disable import/no-cycle */
import filtersRedux from './build';

const { selectors } = filtersRedux;

export default selectors;
